import { useWhatsNewPath } from '@/release/hooks/useWhatsNewPath'
import {
  MenuDivider,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@chakra-ui/react'
import { Crisp } from 'crisp-sdk-web'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { langs } from 'src/i18n'
import { FileIcon, HelpIcon, InfoIcon } from 'src/icons'
import settings from 'src/settings'
import AboutModal from '../modals/AboutModal'

export default function HelpMenuList() {
  const { t, i18n } = useTranslation()
  const aboutModal = useDisclosure()
  const navigate = useNavigate()
  const whatsNewPath = useWhatsNewPath()

  // Documentation is on the website, in the user's language
  const lang = i18n.language.split('-')[0]
  const docsLang = langs.includes(lang as (typeof langs)[number]) ? lang : 'en'

  const handleContact = () => {
    if (Crisp.chat.isVisible()) {
      Crisp.chat.hide()
    } else {
      Crisp.chat.show()
      Crisp.chat.open()
    }
  }

  return (
    <MenuList zIndex={10} shadow="lg">
      {settings.docsUrl && (
        <>
          <MenuItem
            as="a"
            href={`${settings.docsUrl}/${docsLang}/docs`}
            target="_blank"
            rel="noopener noreferrer"
            icon={<FileIcon size={20} />}
          >
            {t('HelpMenu.documentation')}
          </MenuItem>

          <MenuDivider />
        </>
      )}

      <MenuItem icon={<HelpIcon size={20} />} onClick={handleContact}>
        {t('HelpMenu.contact')}
      </MenuItem>

      <MenuDivider />

      <MenuItem
        icon={<FileIcon size={20} />}
        onClick={() => navigate(whatsNewPath)}
      >
        {t('HelpMenu.whatsNew')}
      </MenuItem>

      <MenuItem icon={<InfoIcon size={20} />} onClick={aboutModal.onOpen}>
        {t('HelpMenu.about', { brand: settings.brand.name })}
      </MenuItem>

      {aboutModal.isOpen && <AboutModal isOpen onClose={aboutModal.onClose} />}
    </MenuList>
  )
}
